import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { TemperaturaPipe } from './temperatura.pipe';
import { TemperaturaImagePipe } from './temperatura-image.pipe';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        TemperaturaPipe,
        TemperaturaImagePipe
    ],
    exports: [
        TemperaturaPipe,
        TemperaturaImagePipe
    ],
    providers: [
        TemperaturaPipe,
        TemperaturaImagePipe
    ]
})
export class TemperaturaPipeModule { }
